/**
 * Tiny pub/sub so the Confirmation contacts row (per-contact sent status)
 * and the Buyer notifications panel (send / resend) stay in step without
 * threading state through the 7,000-line OrderDetailModal.
 */
type Listener = (orderId: string) => void;

const listeners = new Set<Listener>();

/** Tell every subscriber the notification history of `orderId` changed. */
export function emitOrderNotificationsChanged(orderId: string): void {
  for (const fn of Array.from(listeners)) fn(orderId);
}

/** Subscribe; returns the unsubscribe function (use in a useEffect cleanup). */
export function onOrderNotificationsChanged(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
